import { scrollToElement, scrollDownToElement } from 'common/utils/scroll';

export default class ScrollToElement {
    constructor(element, offsetTop) {
        this.element = element;
        this.offsetTop = offsetTop || 0;
    }

    handleClick() {
        if (!this.element) return;

        this.element.addEventListener('click', e => {
            e.preventDefault();

            this._scrollToElement(this._getElementToScrollTo(e.currentTarget));
        });
    }

    scroll() {
        this._scrollToElement(this._getElementToScrollTo(this.element));
    }

    scrollDownToElement() {
        const toElement = this._getElementToScrollTo(this.element);

        if (toElement) {
            scrollDownToElement(toElement, this.offsetTop, 200);
        }
    }

    _getElementToScrollTo(element) {
        let toElementId = element.getAttribute('data-scrollto');

        if (toElementId.indexOf('#') === 0) {
            toElementId = toElementId.split('#')[1];
        }

        return document.getElementById(toElementId);
    }

    _scrollToElement(toElement) {
        if (toElement) {
            scrollToElement(toElement, this.offsetTop);
        }
    }
};



// WEBPACK FOOTER //
// ./js/marketing/components/ScrollToElement.js